<template>
	<div>
		<div class="contact tab-box">
			<div class="tab-content" style="display: block;">
				<div class="map clearfix">
					<div class="img">
						<img src="../../../assets/addr.png">
					</div>
					<div class="text">
						<h3>北京总部</h3>
						<div class="list">
							<!-- <p><em><img src="http://www.gdi.com.cn/themes/basic/skin/images/165_icon.png" alt=""></em>邮编：100085 </p> -->
							<p><em><img src="http://www.gdi.com.cn/themes/basic/skin/images/166_icon.png" alt=""></em>全国服务热线：400-810-4006  </p>
							<p> 业务咨询电话：177-0130-1115（王老师）  </p>
							<p><em><img src="http://www.gdi.com.cn/themes/basic/skin/images/168_icon.png" alt=""></em>地址：北京市海淀区上地东路颐泉汇A座310</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="contactform">
			<div class="tit">在线留言</div>
			<div class="tit_p">
				留下您的需求，我们将会尽快与您联系！也可以写邮件给我们。 必须填写的栏目标记为*
			</div>
			<el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="demo-ruleForm" label-width="80px">
				<el-form-item label="姓名" prop="name">
					<el-input v-model="ruleForm.name"></el-input>
				</el-form-item>
				<el-form-item label="电话" prop="phone">
					<el-input v-model="ruleForm.phone"></el-input>
				</el-form-item>
				<el-form-item label="邮箱">
					<el-input v-model="ruleForm.email"></el-input>
				</el-form-item>
				<el-form-item label="留言" prop="message">
					<el-input v-model="ruleForm.message"></el-input>
				</el-form-item>
				<el-form-item label="验证码" prop="verificationCode" style="width: 500px;">
					<el-input v-model="ruleForm.verificationCode" style="width: 200px;float: left;"></el-input>
					<SIdentify :identifyCode="identifyCode" :data-style="{ 'float':'left',	'margin-left': '10px','border-radius': '5px', 'border': '1px solid #ccc','height': '38px', 'cursor': 'pointer'}"
					 ref="code" @click.native="refreshCode()"></SIdentify>
				</el-form-item>
				<el-form-item>
					<el-popconfirm v-if="isSubmit" title="您已提交,是否重新提交" confirm-button-text='提交' cancel-button-text='否' @confirm="submitForm('ruleForm')">
						<el-button type="infor" slot="reference" style="margin-right: 10px;">已提交</el-button>
					</el-popconfirm>
					<el-button type="primary" @click="submitForm('ruleForm')" v-else>提交</el-button>
					<el-button @click="resetForm('ruleForm')">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import SIdentify from '@/components/vue-identify'

	export default {
		data() {
			var phonePass = (rule, value, callback) => {
				if (value.search(/^[1][3,4,5,7,8,9][0-9]{9}$/)) {
					callback(new Error('手机格式有误'));
				} else {
					callback();
				}
			}
			var verificationCodePass = (rule, value, callback) => {
				if (value.toLocaleUpperCase() != this.identifyCode) {
					callback(new Error('验证码有误'));
				} else {
					callback();
				}
			}
			return {
				ruleForm: {
					name: '',
					phone: '',
					email: '',
					message: '',
					verificationCode: ''
				},
				rules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入电话',
						trigger: 'blur'
					}, {
						validator: phonePass,
						trigger: 'blur'
					}],
					message: [{
						required: true,
						message: '请输入留言',
						trigger: 'blur'
					}],
					verificationCode: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}, {
						validator: verificationCodePass,
						trigger: 'blur'
					}]
				},
				identifyCode: '',
				isSubmit: false
			}
		},
		mounted() {
			this.identifyCode = this.random()
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$http.post('message/InsertMessage.do', {
							name: this.ruleForm.name,
							phone: this.ruleForm.phone,
							email: this.ruleForm.email,
							content: this.ruleForm.message,
							ip: this.$device.ip,
							location: this.$device.city,
							device: this.$device.os.name
						}).then(res => {
							this.$notify({
								title: '信息提交成功',
								message: '我们将尽快与您联系',
								type: 'success'
							});
							this.isSubmit = true
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			random() {
				return (Math.random() * 1E10).toString(36).toUpperCase().substring(0, 4)
			},
			refreshCode() {
				this.identifyCode = this.random()
				this.$refs.code.drawPic()
			}
		},
		components: {
			SIdentify
		}
	}
</script>

<style scoped >
	.contact {
		background: #fff;
		padding: 40px;
		display: flow-root;
	}
	
	.contact .tit {
		font-size: 20px;
		color: #333;
	}
	
	.contact .map .img {
		float: left;
		width: 45.4%;
	}
	
	.contact .map .img img {
		border-radius: 10px;
		border: 0;
		max-width: 100% !important;
		max-height: 100% !important;
		display: block;
		font-size: 0px;
	}
		
	.contact .map .text {
		float: right;
		width: 50%;
	}
	
	.contact .map .text h3 {
		font-size: 20px;
		color: #333;
		margin-bottom: 20px;
	}
	
	.contact .map .text p {
		position: relative;
		padding-left: 30px;
		margin-top: 10px;
		font-size: 16px;
	}
	
	.contact .map .text p em {
		position: absolute;
		left: 0px;
		top: 4px;
	}
	
	.contact .map .text p em img {
		max-width: 100% !important;
		max-height: 100% !important;
		display: block;
		font-size: 0px;
	}

	.contactform {
		margin-top: 20px;
		background: #fff;
		padding: 40px;
	}
	
	.contactform .tit {
		font-size: 20px;
		color: #151515;
	}
	
	.contactform .tit_p {
		font-size: 16px;
		margin-top: 10px;
		line-height: 25px;
		color: #666;
		margin-bottom: 30px;
	}
</style>
